import React, { useState, useEffect } from "react";
import useAxios from "../utils/useAxios";
import { BarsArrowUpIcon, BarsArrowDownIcon } from "@heroicons/react/20/solid";
import { ThreeDots } from 'react-loading-icons'

import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

import TableResultsComponent from "./TableResultsComponent";

const swal = require("sweetalert2");

const PanelSearchComponent = () => {
  const api = useAxios();
  const now = new Date();
  const today = new Date().toISOString().split('T')[0];
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];

  const [readOnly, setReadOnly] = useState(false);
  const [showSearchPanel, setshowSearchPanel] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [results, setResults] = useState([]);
  const [fromDate, setFromDate] = useState(firstDayOfMonth);
  const [toDate, setToDate] = useState(today);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);

  // Detectar cambios en el input type_document
  const handleTypeDocument = (e) => {
    const type_document = e.target.value;
    console.log(type_document);
    if (type_document === "all") {
      setReadOnly(true);
      setInputValue("");
    } else {
      setReadOnly(false);
    }
  };

  const toggeShowSearchPanel = () => {
    setshowSearchPanel(!showSearchPanel);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSearch(true);
    const type_document = e.target.type_document.value;
    const count_document = e.target.count_document.value;
    const date_from = e.target.date_from.value;
    const date_to = e.target.date_to.value;
    const document_number = e.target.document_number.value;

    try {
      const response = await api.post("/electronic-documents/list/", {
        type_document,
        count_document,
        date_from,
        date_to,
        document_number
      });
      if (response.data.length === 0) {
        swal.fire({
          title: "No se encontraron resultados",
          text: "Intente con otros parámetros de búsqueda",
          icon: "warning",
          toast: true,
          timer: 6000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }else{
        setResults(response.data);
      }
      setIsLoadingSearch(false);
    } catch (error) {
      swal.fire({
        title: "Error al consultar los comprobantes",
        text: error,
        icon: "error",
        toast: true,
        timer: 6000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
      setIsLoadingSearch(false);
    }
  };

  return (
    <div className="mt-8 sm:mt-6 lg:mt-5">
      <div className="bg-white mx-auto w-11/12 sm:w-5/6 rounded-lg shadow-md p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <h2 className="font-extralight text-lg sm:text-xl">CONSULTA DE COMPROBANTES</h2>
          <button
            onClick={toggeShowSearchPanel}
            disabled={isLoadingSearch}
            type="button"
            className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-full sm:w-auto"
          >
            {showSearchPanel ? (
              <>
                <BarsArrowUpIcon className="h-4 w-4 mr-2"/>
                <span>Ocultar búsqueda</span>
              </>
            ) : (
              <>
                <BarsArrowDownIcon className="h-4 w-4 mr-2"/>
                <span>Mostrar búsqueda</span>
              </>
            )}
          </button>
        </div>
        <div className={showSearchPanel ? 'mt-6' : 'hidden'}>
          <form onSubmit={handleSubmit}>
            <div className="grid gap-4 mb-6 sm:grid-cols-2 lg:grid-cols-2">
              <div>
                <label
                  htmlFor="type_document"
                  className="block mb-1 text-sm font-medium "
                >
                  Tipo de comprobante
                </label>
                <select
                  id="type_document"
                  name="type_document"
                  onChange={handleTypeDocument}
                  className="bg-gray-50 border border-gray-300 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                  required
                >
                  <option value="01">Factura</option>
                  <option value="07">Retención</option>
                  <option value="04">Nota de crédito</option>
                  <option value="05">Nota de débito</option>
                  <option value="06">Guía de remisión</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="count_document"
                  className="block mb-1 text-sm font-medium"
                >
                  Cantidad de comprobates
                </label>
                <select
                  id="count_document"
                  name="count_document"
                  className="bg-gray-50 border border-gray-300 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                  required
                  defaultValue="500"
                >
                  <option value="10">10 últimos</option>
                  <option value="50">50 últimos</option>
                  <option value="100">100 últimos</option>
                  <option value="500">500 últimos</option>
                  <option value="1000">1000 últimos</option>
                  <option value="2000">2000 últimos</option>
                  <option value="3000">3000 últimos</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="date_from"
                  className="block mb-1 text-sm font-medium"
                >
                  Fecha de emisión desde
                </label>
                <input
                  type="date"
                  id="date_from"
                  name="date_from"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="date_to"
                  className="block mb-1 text-sm font-medium"
                >
                  Fecha de emisión hasta
                </label>
                <input
                  type="date"
                  id="date_to"
                  name="date_to"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="document_number"
                  className="block mb-1 text-sm font-medium"
                >
                  Numero de comprobante
                </label>
                <input
                  type="text"
                  id="document_number"
                  name="document_number"
                  className="bg-gray-50 border border-gray-300 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                  placeholder="001-001-000000001"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{9}"
                  disabled={readOnly}
                  readOnly={readOnly}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={isLoadingSearch}
              className="inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <MagnifyingGlassIcon
                className={!isLoadingSearch ? "-ml-0.5 mr-1.5 h-5 w-5" : "hidden"}
                aria-hidden="true"
              />
              <ThreeDots 
                className={isLoadingSearch ? "-ml-0.5 mr-1.5 h-5 w-5" : "hidden"}
                aria-hidden="true"
              />
              Buscar
            </button>
          </form>
        </div>
      </div>
      <TableResultsComponent results={results} />
    </div>
  );
};

export default PanelSearchComponent;
